import styled, { css } from 'styled-components';

import { getFontStyle } from '~components/Text/helper';

export const S = {
  TitleWrapper: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

    img {
      width: 60px;
      height: 60px;
    }

    p {
      margin: 12px 0;
    }
  `,
  ContentWrapper: styled.form`
    display: flex;
    flex-direction: column;
    width: 480px;
    padding: 24px 0;
    text-align: left;
    gap: 24px;
    p {
      margin-top: 4px;
    }

    ${({ theme }) => theme.media.mobile} {
      width: 100%;
    }
  `,
  InputCss: css`
    height: 144px;
  `,
};
